import { render, staticRenderFns } from "./input-button-type.vue?vue&type=template&id=279276d1&scoped=true"
import script from "./input-button-type.vue?vue&type=script&lang=js"
export * from "./input-button-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279276d1",
  null
  
)

export default component.exports